<ng-container *transloco="let t">
  @if (!sequences().length) {
    <span class="text-sm text-text-secondary"><ng-content select="[emptyState]" /></span>
  } @else {
    <p class="text-sm text-text-secondary">
      {{
        t('{ count, plural, =1 {# séquence sélectionnée} other {# séquences sélectionnées} }', {
          count: sequences().length,
        })
      }}
    </p>
    <pxc-sequence-stacks-preview
      class="block w-full"
      [sequences]="sequences()"
      (click)="onMediaClick()"
      (clickMore)="onMoreClick()"
      (deleteMedia)="deleteSequence($event)" />
  }

  <button
    data-testid="open-picker"
    tuiButton
    type="button"
    [appearance]="buttonAppearance"
    [disabled]="isDisabled()"
    (click)="openSequencePicker()">
    {{ buttonLabel }}
  </button>
</ng-container>
